'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var baseAvatar = require('../base/base-avatar.js');
var standardAvatar_module = require('./styles/standard-avatar.module.scss.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const StandardAvatar = (props)=>{
    const { className , ...otherProps } = props;
    return /*#__PURE__*/ React__default.default.createElement(baseAvatar.BaseAvatar, _extends({}, otherProps, {
        className: classnames__default.default(standardAvatar_module.avatar, className),
        variantName: "standard"
    }));
};

exports.StandardAvatar = StandardAvatar;
//# sourceMappingURL=standard-avatar.js.map
